import { watch } from 'vue'
// eslint-disable-next-line no-restricted-imports
import { useMutation, useQuery } from '@vue/apollo-composable'
import { getApolloClientID } from '@/apollo/apollo-client.js'

export const $apollo = {
  query: async (data) => {
    const clientId = getApolloClientID(data.query)
    const options = { ...data, clientId }
    delete options.query
    delete options.variables

    return new Promise((resolve, reject) => {
      try {
        const { result, loading, error } = useQuery(data.query, data.variables || null, options)

        watch(
          [loading, result, error],
          ([val, data, error]) => {
            if (!val && error) {
              console.error('apollo error', error)
              reject(error)
            }
            if (!val && data !== undefined) {
              resolve({ data })
            }
          },
          { immediate: true },
        )
      } catch (e) {
        console.error('apollo catch error', e)
        reject(e)
      }
    })
  },
  mutate: async (data) => {
    const options = { ...data }
    delete options.mutation
    delete options.variables
    return new Promise((resolve, reject) => {
      try {
        const { mutate, onDone, onError } = useMutation(data.mutation, {
          variables: data.variables || null,
          ...options,
        })

        onDone(resolve)
        onError(reject)

        mutate()
      } catch (e) {
        reject(e)
      }
    })
  },
}
